import { DialogContent, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import { factory } from "./Factory";
import PropTypes from "prop-types";
import React from "react";

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

const PagamentoDialog = (props) => {
    const { chave = "", data = null, open, openDialog, user, xappRouteParams, save, Pagamento, verificarPagamento } = props;

    return (
        <React.Fragment>
            {chave !== "" &&
                <XAPPDialog
                    id="Pagamento"
                    open={open}
                    onClose={() => openDialog()}
                    maxWidth={"md"}
                    classes={{ paper: "m-24" }}
                >
                    <div className="flex w-full pl-24">
                        <div style={{ flex: 1 }} />
                        {!data?.blocked &&
                            <XAPPButton
                                className="p-8 "
                                icon="close"
                                type="icon"
                                iconProps="text-24"
                                onClick={() => openDialog()}
                            />
                        }
                    </div>
                    <DialogContent className="min-h-256 p-24 pt-0">
                        {factory(chave, data, { user, xappRouteParams, save, Pagamento, verificarPagamento })}
                    </DialogContent>
                </XAPPDialog>
            }
        </React.Fragment>
    );
};

PagamentoDialog.propTypes = {
    chave: PropTypes.string,
    data: PropTypes.object,
    open: PropTypes.bool,
    openDialog: PropTypes.function,
    save: PropTypes.function,
    user: PropTypes.object,
    xappRouteParams: PropTypes.object,
    Pagamento: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(PagamentoDialog);